module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-wrapper",
    style: ({
      display: _vm.selectedDecade === 0 && !_vm.timelineTransitioning ? 'none' : 'block'
    })
  }, [_c('div', {
    staticClass: "timeline-transition"
  }, [_c('h3', [_vm._v(_vm._s(_vm.selectedDecade + 's'))])]), _vm._v(" "), _c('nav', {
    staticClass: "timeline-nav",
    class: {
      'visible': !_vm.decadeLoading
    }
  }, [_c('a', {
    staticClass: "nav-item nav-item-previous",
    attrs: {
      "href": "#item-previous"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleAnchorClick('anchor-previous')
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav-items"
  }, [_vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.ID
    }, [_c('a', {
      staticClass: "nav-item nav-item-item",
      attrs: {
        "href": '#' + item.ID
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.handleAnchorClick(item.ID)
        }
      }
    }, [_vm._v(_vm._s(item.the_title))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-item nav-item-active-indicator",
    class: {
      'has-transition': !_vm.decadeLoading
    },
    style: ({
      top: _vm.timelineIndicatorTop
    })
  })], 2), _vm._v(" "), _c('a', {
    staticClass: "nav-item nav-item-next",
    attrs: {
      "href": "#item-next"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleAnchorClick('anchor-next')
      }
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "timeline-close",
    class: {
      'visible': !_vm.decadeLoading
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.selectDecade(0)
      }
    }
  }), _vm._v(" "), _c('section', {
    ref: "timeline",
    staticClass: "timeline",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "wheel": function($event) {
        $event.preventDefault();
        return _vm.handleWheel.apply(null, arguments)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.handleAnchorClick('anchor-next')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.handleAnchorClick('anchor-previous')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.selectDecade(0)
      }],
      "touchstart": _vm.handleTouchStart,
      "touchmove": _vm.handleTouchMove
    }
  }, [_c('div', {
    staticClass: "timeline-left",
    class: {
      'has-transition': _vm.decadeLoading
    },
    style: (_vm.timelineLeftStyles)
  }, [_c('div', {
    staticClass: "timeline-left-items-wrapper",
    class: {
      'has-transition': !_vm.decadeLoading
    },
    style: (_vm.timelineLeftItemsStyles)
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: item.ID,
      staticClass: "timeline-image",
      style: (_vm.getItemStyle(item, index)),
      on: {
        "mousemove": _vm.handleImageMouseMove,
        "mouseleave": _vm.handleImageMouseLeave
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "timeline-right",
    class: {
      'has-transition': _vm.decadeLoading
    },
    style: (_vm.timelineRightStyles)
  }, [_c('div', {
    staticClass: "timeline-right-items-wrapper",
    class: {
      'has-transition': !_vm.decadeLoading
    },
    style: (_vm.timelineRightItemsStyles)
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.ID,
      staticClass: "timeline-right-item"
    }, [_c('div', {
      staticClass: "timeline-copy"
    }, [_c('h3', [_vm._v(_vm._s(item.year))]), _vm._v(" "), _c('h2', {
      domProps: {
        "innerHTML": _vm._s(item.the_title)
      }
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.the_content)
      }
    })])])
  }), 0)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1000bb83", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1000bb83","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./timeline/js/components/Timeline.vue
// module id = 56
// module chunks = 0